import { message } from "antd";
import Card from "components/dot/card";
import LoginForm from "components/skeleton/loginform";
import UserApi from "services/apis/sys/user-api";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getItemWithExpiration, removeItem, setItemWithExpiration } from "utils/localStorageUtil";

export type UserLoginDataType = {
  username: string;
  password: string;
};

export default function Login2(props: { setUser?: any }) {
  // useSelector 在刷新页面时会丢失数据
  // 需要本地存储登录信息
  const user = getItemWithExpiration("user");
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (user != null) {
      navigate("/console");
    }
  }, []);

  return (
    <div
      style={{
        // background: "#f5f5f5",
        width: "100%",
      }}
    >
      <Card
        content={LoginForm({
          onFinish: (user: UserLoginDataType) => {
            const fetchUser = async (user: UserLoginDataType) => {
              const result = await UserApi.login({
                username: user.username,
                password: user.password,
              });
              if (result.code === 0 && result.successful) {
                message.info("登录成功");
                setItemWithExpiration("user", result.result, 3600 * 6);
                props.setUser(result.result);
                navigate("/console");
              } else {
                message.error("登陆失败: " + result.msg);
              }
            };
            fetchUser(user);
          },
          isConsole: true,
          isLogin: true,
          toggleIsLogin: null,
          regSuccess: false,
          setRegSuccess: null,
        })}
      />
    </div>
  );
}
